export const Role = {
  Admin: "aws.cognito.signin.user.admin",
  User: "User", //TODO- need to config new roles
};

export const APP_USER = {
  roleId: 1,
  roleName: "APP_USER",
  displayName: "App User",
};

export const ORG_OWNER = {
  roleId: 2,
  roleName: "ORG_OWNER",
  displayName: "Owner",
};

export const ORG_ADMIN = {
  roleId: 3,
  roleName: "ORG_ADMIN",
  displayName: "Admin",
};

export const ORG_STANDARD_USER = {
  roleId: 4,
  roleName: "ORG_STANDARD_USER",
  displayName: "User",
};

export const ORG_SUPER_ADMIN = {
  roleId: 5,
  roleName: "ORG_SUPER_ADMIN",
  displayName: "Super Admin",
};

export const ALL_ROLES = [
  APP_USER,
  ORG_OWNER,
  ORG_ADMIN,
  ORG_STANDARD_USER,
  ORG_SUPER_ADMIN,
];

export const ORG_ROLES = [
  ORG_OWNER,
  ORG_ADMIN,
  ORG_STANDARD_USER,
  ORG_SUPER_ADMIN,
];

export const INVITE_ROLES = [ORG_SUPER_ADMIN, ORG_ADMIN, ORG_STANDARD_USER];

export const ADMIN_CHANGE_ROLES = [ORG_ADMIN, ORG_STANDARD_USER];

const roleDisplayNames = {
  2: "Owner",
  3: "Admin",
  4: "User",
  5: "Super Admin",
};
const roleDisplayId = {
  owner: 2,
  admin: 3,
  user: 4,
  "super admin": 5,
};

const userStatus = {
  ACCEPTED: "Active",
  INVITED: "Pending",
  REJECTED: "Rejected",
  DELETED: "Deleted",
};

export const getRoleDisplayText = (roleId) => {
  return roleDisplayNames[roleId.toString()];
};

export const getStatusDisplayText = (status) => {
  return userStatus[status.toUpperCase()] || status;
};

export const getDisplayRoleId = (displayName) => {
  return roleDisplayId[displayName.toString().toLowerCase()];
};
